import $ from "utils/net";
import Config from "./config";

export interface CreateBuyOfferResponse {
    buyOfferId: string;
}

export interface CreateSellOfferResponse {
    offerId: string;
}

export async function createBuyOffer(amount: number, currency?: string): Promise<CreateBuyOfferResponse> {
    const data = await $.promisePostJSON<CreateBuyOfferResponse | { error: string }>(
        Config.softionAPI + '/ptop_payments/createBuyOfferForPlayer',
        {
            body: {
                amount,
                ...(currency ? { currency } : {}),
            }
        }
    );
    if ('error' in data) throw data;
    return data;
}

export async function createSellOffer(amount: number): Promise<CreateSellOfferResponse> {
    const data = await $.promisePostJSON<CreateSellOfferResponse | { error: string }>(
        Config.softionAPI + '/ptop_payments/createSellOfferForPlayer',
        {
            body: { amount }
        }
    );
    if ('error' in data) throw data;
    return data;
}
